<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2021-07-13 08:36:03
 * @LastEditors: xiawenlong
 * @LastEditTime: 2026-05-09 11:33:34
-->
<template>
  <div class="container">
    <div class="title">实时累积交易金额（元）</div>
    <div :class="['count', { highlight: isHighlight }]">
      <div class="box-item">
        <li
          v-for="(item, index) in numArr"
          :key="index"
          :class="{ 'number-item': !isNaN(item), 'mark-item': isNaN(item) }"
        >
          <span v-if="!isNaN(item)">
            <i ref="numberItem">0123456789</i>
          </span>
          <span v-else class="comma">{{ item }}</span>
        </li>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Flop',
  data() {
    return {
      numArr: [0, 0, 0, 0, 0, 0, 0, 0, 0],
      num: 0,
      isHighlight: false,
    }
  },
  methods: {
    async initData(data) {
      if (this.num != data) {
        this.isHighlight = true
        setTimeout(() => {
          this.isHighlight = false
        }, 2000)
      }
      this.num = data
      this.toOrderNum(this.num)
      this.$nextTick(() => {
        this.setNumberTransform()
      })
    },
    // 设置文字滚动
    setNumberTransform() {
      const numberItems = this.$refs.numberItem // 拿到数字的ref，计算元素数量
      const numberArr = this.numArr.filter(item => !isNaN(item))
      // 结合CSS 对数字字符进行滚动,显示订单数量
      for (let index = 0; index < numberItems.length; index++) {
        const elem = numberItems[index]
        elem.style.transform = `translate(-50%, -${numberArr[index] * 10}%)`
      }
    },
    // 处理总订单数字
    toOrderNum(num) {
      console.log(`output->num`, num)
      num = num.toString()
      // 把订单数变成字符串
      if (num.length < 9) {
        num = '0' + num // 如未满9位数，添加"0"补位
        this.toOrderNum(num) // 递归添加"0"补位
      } else if (num.length === 9) {
        // 订单数中加入逗号
        // num = num.slice(0, 3) + ',' + num.slice(3, 6) + ',' + num.slice(6, 9)
        this.numArr = num.split('') // 将其便变成数据，渲染至滚动数组
      } else {
        // 订单总量数字超过9位显示异常
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.container {
  position: relative;
  box-sizing: border-box;
  width: 1587px;
  text-align: center;
  height: 256px;
  background: url('~@/img/agriculture/flop_bg.png');
  padding-top: 23px;

  .title {
    font-weight: bold;
    font-size: 48px;
    color: #fff;
    line-height: 48px;
    text-align: center;
    margin-bottom: 25px;
  }

  .count {
    transition: transform 0.5s ease, color 0.5s ease;
    position: absolute;
    width: 100%;
    display: flex;
    justify-content: center;
    font-weight: 800;

    .box-item {
      letter-spacing: 3px;
      writing-mode: vertical-lr;
      text-orientation: upright;
      /*文字禁止编辑*/
      -moz-user-select: none;
      /*火狐*/
      -webkit-user-select: none;
      /*webkit浏览器*/
      -ms-user-select: none;
      /*IE10*/
      -khtml-user-select: none;
      /*早期浏览器*/
      user-select: none;
      /* overflow: hidden; */
    }

    /* 默认逗号设置 */
    .mark-item {
      width: 20px;
      height: 100px;
      line-height: 100px;
      font-size: 30px;
      position: relative;

      & > span {
        position: absolute;
        width: 100%;
        right: 42px;
        bottom: 0;
      }
    }

    /*滚动数字设置*/
    .number-item {
      text-shadow: 0px 0px 22px #4c77ef;
      transition: transform 0.5s ease, color 0.5s ease;
      width: 96px;
      height: 118px;
      line-height: 118px;
      font-weight: bold;
      font-size: 87px;
      color: #ffffff;
      margin-right: 57px;
      background: url('~@/img/agriculture/num_bg.png');
      list-style: none;

      & > span {
        position: relative;
        display: block;
        width: 100%;
        height: 100%;
        writing-mode: vertical-rl;
        text-orientation: upright;
        overflow: hidden;

        & > i {
          font-style: normal;
          position: absolute;
          top: 15px;
          left: 50%;
          transform: translate(-50%, 0);
          transition: transform 2s ease-in-out;
          letter-spacing: 15px;
        }
      }
    }

    &.highlight {
      .number-item {
        transform: scale(1.2);
        color: #7fc1ff;
      }
    }

    .number-item:last-child {
      margin-right: 0;
    }
  }
}
</style>
